// For get pyament terms
export const GET_ADMIN_BILLING_EVENTS = "GET_ADMIN_BILLING_EVENTS"
export const GET_ADMIN_BILLING_EVENTS_SUCCESS = "GET_ADMIN_BILLING_EVENTS_SUCCESS"
export const GET_ADMIN_BILLING_EVENTS_ERROR = "GET_ADMIN_BILLING_EVENTS_ERROR"
export const GET_BILLING_EVENTS_FILTER_OPTIONS = "GET_BILLING_EVENTS_FILTER_OPTIONS"
export const GET_BILLING_EVENTS_FILTER_OPTIONS_SUCCESS = "GET_BILLING_EVENTS_FILTER_OPTIONS_SUCCESS"
export const GET_BILLING_EVENTS_FILTER_OPTIONS_ERROR = "GET_BILLING_EVENTS_FILTER_OPTIONS_ERROR"
